import '../../accounting/accounting.css';
import { AppDataGrid, type AppColumn } from '../../../components/AppDataGrid';
import { AppToolbar } from '../../../components/AppToolbar';
import { FormTitle } from '../../../components/FormTitle';
import { ExportMenu } from '../../accounting/ExportMenu';
import { useFetchMs } from '../../../hooks/useFetchMs';
import { useLanguages, type Language } from './systemMasters';

interface Props { onHome?: () => void; }

/**
 * Settings ▸ System Management ▸ Current Language — read-only view of the
 * UI-language toggle record (legacy CurrentLanguage_ListView: English / Chinese).
 */
export function CurrentLanguagePage({ onHome }: Props) {
  const { data: rows = [], isFetching, refetch } = useLanguages();
  const loadMs = useFetchMs(isFetching);

  const columns: AppColumn<Language>[] = [
    { field: 'english', header: 'English', width: 160, align: 'center', sortable: false, text: (r) => (r.english ? 'Yes' : 'No'),
      render: (r) => <span className={`cellcheck${r.english ? ' on' : ''}`} role="img" aria-label={r.english ? 'Enabled' : 'Disabled'} /> },
    { field: 'chinese', header: 'Chinese', width: 160, align: 'center', sortable: false, text: (r) => (r.chinese ? 'Yes' : 'No'),
      render: (r) => <span className={`cellcheck${r.chinese ? ' on' : ''}`} role="img" aria-label={r.chinese ? 'Enabled' : 'Disabled'} /> },
  ];

  return (
    <div className="acc-page">
      <div className="acc-top">
        <div className="acc-bc">
          <a onClick={onHome}>Home</a><i className="ti ti-chevron-right" />
          <span>Settings</span><i className="ti ti-chevron-right" /><span>System Management</span><i className="ti ti-chevron-right" />
          <span style={{ color: '#4a3728', fontWeight: 600 }}>Current Language</span>
        </div>
        {/* BO UI Standard v2: FormTitle + subtitle ON the grey page — never inside the card. */}
        <FormTitle pageId="sm-language" auditFormName="Current Language" loadMs={loadMs ?? null} loading={isFetching} />
        <div className="acc-sub">{rows.length} item{rows.length === 1 ? '' : 's'}</div>
      </div>
      <div className="acc-body">
        {/* Action toolbar — its OWN full-width row (BO UI Standard §6); Export far right. */}
        <AppToolbar
          onRefresh={() => void refetch()} refreshing={isFetching}
          right={
            <span className="app-toolbar__spacer">
              <ExportMenu triggerClassName="ca-btn" filename="CurrentLanguage" headers={['English', 'Chinese']} rows={rows.map((r) => [r.english ? 'Yes' : 'No', r.chinese ? 'Yes' : 'No'])} />
            </span>
          }
        />
        {/* ONE white grid card — grid + its single footer only. */}
        <div className="acc-card">
          <AppDataGrid<Language> rows={rows} columns={columns} getRowId={(r) => r.id}
            loading={isFetching} emptyText="No language record found." />
        </div>
      </div>
    </div>
  );
}
